export const SITE_INFO = {
  contact: {
    email: 'partners@es.edenred.info',
    phone: '91 910 07 54',
  },
  links: {
    clubEdenred: 'https://youlend.com/apply/edenred/es/welcome?tpi=C:Banner',
    food: 'https://www.youtube.com/watch?v=ebC1rjTNhTw',
  },
}
